<template>
  <div class="topman">
    使用情况
    <!-- <el-tabs v-model="activeName" class="el-tabs" v-if="userinfo.tenantType === 0">
      <el-tab-pane label="车辆" name="first"></el-tab-pane>
      <el-tab-pane label="运营" name="second"></el-tab-pane>
    </el-tabs>
     <div v-if="activeName === 'first' && userinfo.tenantType === 0">
      <First />
     </div>
     <div v-if="activeName === 'second' && userinfo.tenantType === 0">
      <Second />
     </div>
     <div v-if="userinfo.tenantType === 22">
      <Three />
     </div>
     <div v-if="userinfo.tenantType === 1 || userinfo.tenantType === 3">欢迎使用Listek物联网系统</div> -->
  </div>
</template>
<script>
// import First from './components/First.vue'
// import Second from './components/Second.vue'
// import Three from './components/Three.vue'
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['userinfo'])
  },
  components: {
    // First,
    // Second,
    // Three
  },
  data() {
    return {
      activeName: 'first'
    }
  },
  created() {},
  mounted() {},
  methods: {
  }
}
</script>

<style lang="scss">
.el-tabs__item {
  padding: 0px 10px;
  cursor: pointer;
}
.el-tabs__nav-wrap::after {
  height: 0px;
}

.el-tabs__item:hover {
  color: #0f73e6;
}
.el-tabs__item.is-active {
  color: #0f73e6;
}

.el-tabs__active-bar {
  background-color: #0f73e6;
}
</style>
<style lang="scss" scoped>
.topman {
  .el-tabs {
    position: fixed;
    right: 30px;
    top: 70px;
    z-index: 1999;
  }
  .top-layout {
    display: flex;
    justify-content: space-between;
    // flex-direction: row;
    align-items: center;
    min-width: 1200px;
    .zw {
      width: 1.11vw;
      min-width: 20px;
    }

    .item-layout {
      width: px2vw(320.5);
      height: px2vw(153);
      min-width: 260.5px;
      min-height: 153px;
      border-radius: px2vw(8);
      background: #f5f5f5;
      border: 1px solid #969797;

      .hs {
        display: flex;
        flex-direction: row;
        align-items: baseline;
        margin-left: px2vw(22);
        > :first-child {
          font-family: PuHuiTi-700;
          font-size: 48px;
          line-height: 65.86px;
          text-align: left;
          color: #555555;
        }
        > :last-child {
          font-family: PingFang SC;
          font-size: 14px;
          font-weight: 400;
          line-height: 19.6px;
          margin-left: px2vw(8);
          color: #555555;
        }
      }
      .item-content {
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding: px2vw(20);

        .left {
          display: flex;
          flex-direction: row;
          align-items: center;
          img {
            width: 24px;
            height: 24px;
          }
          .img2 {
            width: 16px;
            height: 16px;
          }
          div {
            font-family: PingFang SC;
            font-size: 14px;
            font-weight: 400;
            line-height: 14px;
            color: #555555;
            margin-left: px2vw(8);
          }
        }

        .right {
          display: flex;
          flex-direction: row;
          align-items: center;
          cursor: pointer;
          img {
            width: 16px;
            height: 16px;
            margin-left: px2vw(4);
          }
          div {
            font-family: PingFang SC;
            font-size: 14px;
            font-weight: 400;
            line-height: 14px;
            color: #8d96a9;
          }
        }
      }
    }
  }

  .gzqk-gzclqk {
    display: flex;
    justify-content: space-between;
    background: #f5f5f5;
    width: 100%;
    height: px2vw(360);
    min-width: 1200px;
    min-height: 360px;
    border-radius: px2vw(8);
    border: 1px;
    margin-top: px2vw(20);

    .lines {
      width: 1px;
      background: #e5e3ec;
      height: px2vw(360);
      min-height: 360px;
      min-width: 1px;
    }
    .gzqk {
      width: 100%;
      position: relative;
    }

    .gzclqk {
      width: 100%;
      position: relative;
    }
  }

  .xzqs {
    display: flex;
    background: #f5f5f5;
    width: 100%;
    min-width: 1200px;
    min-height: 360px;
    height: px2vw(360);
    border-radius: px2vw(8);
    border: 1px;
    margin-top: px2vw(20);
    position: relative;
    z-index: 9;
  }

  .simksyqk {
    display: flex;
    background: #f5f5f5;
    width: 100%;
    height: px2vw(360);
    min-width: 1200px;
    min-height: 360px;
    border-radius: px2vw(8);
    border: 1px;
    margin-top: px2vw(20);
    position: relative;
    z-index: 9;
  }

  .text-select {
    display: flex;
    position: absolute;
    left: 0;
    top: 22px;
    justify-content: space-between;
    align-items: center;
    z-index: 10;
    width: 100%;
    padding-left: 20px;
    padding-right: 20px;
    .text {
      font-family: PingFang SC;
      font-size: 16px;
      font-weight: 500;
      line-height: 22.4px;
      color: #0c2358;
    }
  }

  .margin-left10 {
    margin-left: 10px;
  }

  .select-width {
    width: 160px;
  }

  .echarts-div {
    width: 100%;
    height: 100%;
  }

  *,
  :after,
  :before {
    box-sizing: border-box;
  }
}
</style>
